import { useEffect, useState } from 'react';

const listeners = ['coins', 'score'];

export default function useGameLog(eventBus) {
  const [logs, setLogs] = useState('');

  const onItemUpdate = ({ data: { str, count } }) => {
    setLogs((prev) => prev + `${str}${count}`);
  };

  useEffect(() => {
    if (!eventBus) return;
    listeners.forEach((item) => eventBus.addEventListener(`${item}:update`, onItemUpdate));
  }, [eventBus]);

  return logs;
}

function parseString(input) {
  let score = 0;
  let coins = 0;

  const operations = {
    GS: (value) => (score += value),
    GC: (value) => (coins += value),
    BS: (value) => (score -= value),
    BC: (value) => (coins -= value),
  };

  const regex = /[A-Za-z]+\d+/g;
  const result = input.match(regex) || [];

  result.forEach((item) => {
    const type = item.slice(0, 2);
    const value = parseInt(item.slice(2), 10);

    if (operations?.[type]) {
      operations[type](value);
    }
  });

  return { score, coins };
}
